export const logType = {
  'LOG': 1,
  'INFO': 2,
  'WARN': 3,
  'ERROR': 4
};

/**
 * log - prints logs in the console
 * @param {*} type console message type
 * @param {*} message text to print
 */
export const log = (type, message) => {
  if (DEBUG === 'true') {
    let logType = ['INFO', 'WARN', 'ERROR'].indexOf(type) !== -1 ? type.toLowerCase() : 'log';
    console[logType](message);
  }
};



// WEBPACK FOOTER //
// ./src/misc/log/index.js